import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-cloud-arrow-up-icon',
  imports: [],
  templateUrl: './cloud-arrow-up-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cloud-arrow-up-icon.component.scss',
})
export class CloudArrowUpIconComponent {}
